'use client';

const defaultProps = {
  iconStyle: "default",
  iconPosition: "lead",
  inputSpacing: "md",
  inputSize: "fluid"
};
export {
  defaultProps
};
